'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
require('./constants-0cf35288.js');
require('react');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
require('./pill-80fa7aa7.js');
require('./form-field-568b9a9c.js');
require('./asterisk-436ee6b3.js');
require('./field-label-4ed9b7f8.js');
require('./field-hint-cc714695.js');
require('./messages-f8f39369.js');
require('./loader-f28c8bde.js');
require('./select-6c9d108c.js');
require('./select-item-7fd13c43.js');
require('./select-title-65885e9f.js');
require('./styles-a9f2fe66.js');
require('./calendar-date.styles-9072cd1e.js');
require('./styles-20009c57.js');
require('./index.esm-c41adfff.js');
require('./fa-icon-d6ca067a.js');
require('./field.styles-a36bbd7b.js');
require('./styles-424066e0.js');
require('./overlay-878554b6.js');
var paper = require('./paper-e6cfe656.js');
require('./style-d0a65e48.js');
require('./styles-558f9987.js');
require('./native-select.styles-3602a739.js');
require('./select-wrapper.styles-0104a777.js');
require('./device.context-f96381a3.js');
require('./mobile-detect-2421ba00.js');
require('./styles-38df6401.js');
require('./styles-f287cb5d.js');
require('./status-indicator-f5477803.js');
require('./styles-6fa8f6cf.js');
require('./text-break-b3fca248.js');
require('./tooltip-8d9d80ea.js');

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  width: 360px;\n  position: relative;\n"], ["\n  width: 360px;\n  position: relative;\n"])));
var templateObject_1;

var Overlay = styled__default.div(templateObject_1$1 || (templateObject_1$1 = tslib_es6.__makeTemplateObject(["\n  position: fixed;\n  z-index: ", ";\n  inset: 0px;\n"], ["\n  position: fixed;\n  z-index: ", ";\n  inset: 0px;\n"])), function (_a) {
    var zIndex = _a.zIndex;
    return zIndex;
});
var StyledPortalPaper = styled__default(paper.Paper)(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  margin-top: 8px;\n  padding: 12px 0;\n  overflow: auto;\n  position: absolute;\n  max-height: 272px;\n  height: auto;\n  box-shadow: none;\n  border: 1px solid ", ";\n  z-index: 1;\n"], ["\n  margin-top: 8px;\n  padding: 12px 0;\n  overflow: auto;\n  position: absolute;\n  max-height: 272px;\n  height: auto;\n  box-shadow: none;\n  border: 1px solid ", ";\n  z-index: 1;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyLight;
});
var DropdownSpinnerContainer = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"])));
var DropdownNoContentContainer = styled__default.div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n"], ["\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n"])));
var NoContentTitle = styled__default.div(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  font: 500 16px/22px ", ";\n  color: ", ";\n"], ["\n  font: 500 16px/22px ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
});
var NoContentSubTitle = styled__default.div(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  font: 400 14px/22px ", ";\n  color: ", ";\n"], ["\n  font: 400 14px/22px ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
});
var templateObject_1$1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

(function (SearchInputDropdownMode) {
    SearchInputDropdownMode["Spinner"] = "Spinner";
    SearchInputDropdownMode["EmptyContent"] = "EmptyContent";
    SearchInputDropdownMode["Content"] = "Content";
})(exports.SearchInputDropdownMode || (exports.SearchInputDropdownMode = {}));

exports.Container = Container;
exports.DropdownNoContentContainer = DropdownNoContentContainer;
exports.DropdownSpinnerContainer = DropdownSpinnerContainer;
exports.NoContentSubTitle = NoContentSubTitle;
exports.NoContentTitle = NoContentTitle;
exports.StyledPortalPaper = StyledPortalPaper;
